import { Container } from 'ui';
import { Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router';
import { StoreType } from '@tock/shared/utils/connect';
import {
  iconSpacing,
  listDisplayContainer,
} from 'routes/protected/account/profile/profilePlaylistsRouteCssDefs';
import { processPlaylistsToPlaylistDescriptors } from 'components/profile/playlists/BusinessPlaylistsDialogListsPage';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PlaylistTypeIcon from 'components/profile/playlists/PlaylistTypeIcon';
import ProfileListSideNav from 'components/profile/ProfileListSideNav';
import ProfilePlaylistDetailsRoute from './ProfilePlaylistDetailsRoute';
import useLoadPlaylists, { useInitializePlaylistDefaults } from 'hooks/useLoadPlaylists';

const ProfilePlaylistsRoute: React.FunctionComponent = () => {
  const { playlists, isInitialized } = useSelector((state: StoreType) => ({
    playlists: state.patron.playlists.data,
    isInitialized: state.patron.playlists.isInitialized,
  }));
  const match = useRouteMatch();
  const history = useHistory();
  useLoadPlaylists();

  const playlistDescriptors = useMemo(() => {
    return processPlaylistsToPlaylistDescriptors(playlists || []);
  }, [playlists]);

  useInitializePlaylistDefaults(playlistDescriptors);

  const navItems = playlistDescriptors.map((playlistDescriptor) => ({
    id: playlistDescriptor.id,
    text: (
      <div css={listDisplayContainer}>
        <PlaylistTypeIcon css={iconSpacing} playlistType={playlistDescriptor.playlistType} />{' '}
        {playlistDescriptor.name}{' '}
      </div>
    ),
    to: `${match.path}/${playlistDescriptor.id}`,
  }));

  const handleDeletePlaylistDone = () => {
    history.replace(match.path);
  };

  const shouldRedirect =
    playlistDescriptors.filter((descriptor) => descriptor.id < 0).length === 0 &&
    isInitialized &&
    playlistDescriptors.length > 0;

  return (
    <Container>
      <Switch>
        <Route path={`${match.path}/:playlistId`}>
          {({ match }) => {
            return (
              <ProfileListSideNav navItems={navItems}>
                <ProfilePlaylistDetailsRoute onDeletePlaylistDone={handleDeletePlaylistDone} />
              </ProfileListSideNav>
            );
          }}
        </Route>
        {shouldRedirect && <Redirect to={`${match.path}/${playlistDescriptors[0].id}`} />}
      </Switch>
    </Container>
  );
};

export default ProfilePlaylistsRoute;
